document.addEventListener('DOMContentLoaded', function() {

	[].forEach.call( document.querySelectorAll('ul.contacts li a'), function ( contact ) {
	    contact.addEventListener('click', function (e) {

			var windowWidth = window.innerWidth;
			var dataContact = contact.getAttribute('data-contact');
			var dataAdviserId = contact.getAttribute('data-adviser');
			var idContact = 'ul#contacts_'+dataAdviserId+' li a';
			var idAdviser = '#contact_info_'+dataAdviserId;

			if( dataAdviserId && windowWidth > 768 ) {
				e.preventDefault();
				[].forEach.call(document.querySelectorAll(idContact), function (el) {
					el.classList.remove('active');
				});
				this.classList.add('active');
				document.querySelector( idAdviser ).classList.add('show');
				document.querySelector( idAdviser ).textContent = dataContact;
			}
 		
	    })
	});

});

